import { io } from 'socket.io-client';
import { API_URL } from 'config';
import storage from 'utils/storage';

/** Origin only — Socket.IO path is /socket.io (not under /api/v1). */
function socketOrigin() {
  try {
    const u = new URL(API_URL);
    return `${u.protocol}//${u.host}`;
  } catch {
    return String(API_URL || '').replace(/\/api\/v1\/?$/, '');
  }
}

let socket = null;
let ticketRoomId = null;
const listeners = new Set();

function notify(event, payload) {
  listeners.forEach((fn) => {
    try {
      fn(event, payload);
    } catch (_) {
      /* ignore listener errors */
    }
  });
}

export function connectTicketSocket() {
  const token = storage.getToken();
  if (!token) return null;

  if (socket?.connected) return socket;

  if (socket) {
    try {
      socket.auth = { token };
      socket.connect();
      return socket;
    } catch (_) {
      /* recreate below */
    }
  }

  socket = io(socketOrigin(), {
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    auth: { token },
    extraHeaders: { Authorization: `Bearer ${token}` },
    reconnection: true,
    reconnectionAttempts: 20,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 15000,
    timeout: 20000,
  });

  socket.on('connect', () => {
    socket.emit('ticketInboxJoin', {});
    if (ticketRoomId) {
      socket.emit('ticketJoin', { ticketId: ticketRoomId });
    }
  });

  socket.on('ticketUpdated', (payload) => {
    notify('ticketUpdated', payload);
  });

  socket.on('connect_error', (err) => {
    console.warn('Ticket socket connect_error', err?.message || err);
  });

  return socket;
}

export function subscribeTicketSocket(handler) {
  listeners.add(handler);
  connectTicketSocket();
  return () => listeners.delete(handler);
}

export function joinAdminTicketRoom(ticketId) {
  if (!ticketId) return;
  ticketRoomId = ticketId;
  const s = connectTicketSocket();
  if (s?.connected) {
    s.emit('ticketJoin', { ticketId });
  }
}

export function leaveAdminTicketRoom(ticketId) {
  const s = socket;
  const id = ticketId || ticketRoomId;
  if (s?.connected && id) {
    s.emit('ticketLeave', { ticketId: id });
  }
  if (!ticketId || ticketId === ticketRoomId) {
    ticketRoomId = null;
  }
}

export function disconnectTicketSocket() {
  ticketRoomId = null;
  listeners.clear();
  if (socket) {
    try {
      socket.removeAllListeners();
      socket.disconnect();
    } catch (_) {}
    socket = null;
  }
}
